module.exports = __webpack_public_path__ + "static/media/cross.ad587a4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cross.svg
// module id = 89
// module chunks = 1